import { login, getLastEmail } from "../auth_store.js";
import { authLayout, field, btnPrimary, alertBox, bindForm } from "./auth_shell.js";
import { navigate } from "../router.js";
import { t } from "../i18n.js";

export function renderLogin(root) {
  const last = getLastEmail();
  root.innerHTML = authLayout({
    title: t("Welcome back"),
    subtitle: t("Sign in to manage your apartments and publish tours."),
    childrenHtml: `
      <div id="login-alert"></div>
      <form class="portal-form" novalidate>
        ${field({ id: "email", label: t("Email"), type: "email", placeholder: "you@studio.com", autocomplete: "email", value: last })}
        ${field({ id: "password", label: t("Password"), type: "password", placeholder: "••••••••", autocomplete: "current-password" })}
        <div class="portal-form__row">
          <label class="portal-check">
            <input type="checkbox" name="remember" checked />
            <span>${t("Remember me")}</span>
          </label>
          <a class="portal-link" href="#/forgot-password">${t("Forgot password?")}</a>
        </div>
        ${btnPrimary(t("Sign in"), { type: "submit" })}
      </form>
    `,
    footerHtml: `
      <span class="portal-muted">${t("New here?")}</span>
      <a class="portal-link portal-link--strong" href="#/register">${t("Create an account")}</a>
    `,
  });

  bindForm(root, (values) => {
    const alertEl = root.querySelector("#login-alert");
    const res = login({
      email: values.email,
      password: values.password,
      remember: values.remember === "on",
    });
    if (!res.ok) {
      alertEl.innerHTML = alertBox(t(res.error));
      return;
    }
    navigate("/dashboard", true);
  });
}
